import { render, staticRenderFns } from "./configuration-local-assays-protocols-modal.vue?vue&type=template&id=204b4d3a&scoped=true&"
import script from "./configuration-local-assays-protocols-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-protocols-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-protocols-modal.scss?vue&type=style&index=0&id=204b4d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b4d3a",
  null
  
)

export default component.exports